import React, {useEffect} from "react";

export interface ModalProps {
    title?: string | null | undefined,
    children: JSX.Element,
    refer: React.ForwardedRef<any>,
    showModal: boolean,
    className?: string,
    withoutPadding?: boolean
}
export default function Modal({refer, title, children, className, withoutPadding}: ModalProps){
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    return (
        <div className={`fixed top-0 left-0 w-full h-full z-50`}>
            <div
                className="flex h-full justify-center items-start text-center min-h-screen transition-opacity bg-modal-bg">
                <div ref={refer}
                     className="inline-block w-full md:max-w-sm lg:max-w-[50%] my-auto mx-2 text-left rounded-xl bg-white dark:bg-blue-gray-900 overflow-hidden align-bottom transition-all transform">
                    <div className={`items-center my-auto relative max-w-7xl ${className ?? ''}`}>
                        <div className="grid grid-cols-1">
                            <div className={`mr-auto ml-auto w-full max-h-[80vh] overflow-y-auto min-w-xs ${withoutPadding? 'py-4' : 'p-4'}`}>
                                <div className="py-4">
                                    <h3 className="text-lg text-black dark:text-white text-center">{title}</h3>
                                    <div className="flex flex-col items-center mt-4">
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
